export default {
    requisicoes: [],
	requisicoesBaixa: [],
    requisicao: {},
    ultimaAtualizacaoLista: Date
}